export const artSlotNumbers = [1, 2] as const;

export const artSlotFields = [
  { key: "platform_icon", labelKey: "metadata.binding.platformIcon", styles: [], layerGroup: "time" },
  {
    key: "member_only",
    labelKey: "metadata.binding.memberOnly",
    styles: [{ key: "member_only", labelKey: "schedule.memberOnly" }],
    layerGroup: "time",
  },
  {
    key: "subtitle",
    labelKey: "metadata.binding.subtitle",
    styles: [
      { key: "stream_subtitle", labelKey: "metadata.field.streamSubtitle" },
      { key: "stream_subtitle_compact", labelKey: "metadata.field.streamSubtitleCompact" },
    ],
    layerGroup: "stream",
  },
  {
    key: "time",
    labelKey: "metadata.binding.time",
    styles: [
      { key: "stream_time", labelKey: "metadata.field.streamTime" },
      { key: "stream_time_compact", labelKey: "metadata.field.streamTimeCompact" },
    ],
    layerGroup: "time",
  },
  {
    key: "title",
    labelKey: "metadata.binding.title",
    styles: [
      { key: "stream_title", labelKey: "metadata.field.streamTitle" },
      { key: "stream_title_compact", labelKey: "metadata.field.streamTitleCompact" },
    ],
    layerGroup: "stream",
  },
] as const;

export const artSlotBindings = artSlotNumbers.flatMap((number) =>
  artSlotFields.map((field) => `slot${number}.${field.key}` as const),
);

export const artSlotStyles = artSlotFields.map((field) => field.styles).flat();
export const artSlotStyleNames = artSlotStyles.map((style) => style.key);
